import { EngineResult } from 'json-rules-engine';
import { call } from 'redux-saga/effects';
import { ICheckLegacyRules } from '../../../../entities/ICheckRules';
import { runAction } from './action';

export function* triggerStatement(results: EngineResult, args: ICheckLegacyRules, result: boolean) {
	for (const resultItem in results.events) {
		const actionPromiseResults = yield call(runAction, {
			actions: results.events[resultItem].params.actions,
			rule: results.events[resultItem].params.rule,
			checkType: args.checkType,
			windowId: args.windowId,
			validate: args.validate
		});
		result = actionPromiseResults.filter(Boolean).length > 0;
	}

	return result;
}
